import {NgModule} from "@angular/core";
import {Http, RequestOptions, XHRBackend} from "@angular/http";
import {CerbaAuthService, httpFactory} from "@digicerba/common";
import {ResourcesClient} from "./resources.client";
import {
  HttpClient,
  IArticlesWebServiceClient,
  IAuditWebServiceClient,
  ICategoriesWebServiceClient,
  ICommandeMaterielWebServiceClient,
  ICorrespondantWebServiceClient,
  IGedWebServiceClient,
  IGestionCatalogueWebServiceClient,
  INotificationsCommonWebServiceClient,
  IUserInformationsWebServiceClient
} from "@resources/resources";
import { CORRESPONDANT_CLIENT, USER_INFO_CLIENT } from "@digicerba/common/resources/tokens/injectionTokens";

var resources: Array<any> = [
  /** Liste des resources du fichier resources.ts*/
  IArticlesWebServiceClient,
  ICategoriesWebServiceClient,
  ICorrespondantWebServiceClient,
  ICommandeMaterielWebServiceClient,
  IGestionCatalogueWebServiceClient,
  IAuditWebServiceClient,
  IUserInformationsWebServiceClient,
  INotificationsCommonWebServiceClient,
  IGedWebServiceClient,
  CerbaAuthService,
  { provide :  CORRESPONDANT_CLIENT, useClass : ICorrespondantWebServiceClient},
  { provide : USER_INFO_CLIENT, useClass : IUserInformationsWebServiceClient}
];

@NgModule({
  providers: [...resources,
    {
      provide: Http,
      useFactory: httpFactory,
      deps: [XHRBackend, RequestOptions, CerbaAuthService]
    },
    {provide: HttpClient, useClass: ResourcesClient}]
})
export class ResourcesModule {

}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-commande-materiel/digicerba-commande-materiel-web/src/angular/cerba/src/app/common/resources/resources.module.ts